module.exports = {"371321001":"界湖街道","371321101":"岸堤镇","371321102":"孙祖镇","371321103":"双堠镇","371321104":"青驼镇","371321105":"张庄镇","371321106":"砖埠镇","371321109":"大庄镇","371321110":"辛集镇","371321111":"蒲汪镇","371321112":"湖头镇","371321113":"苏村镇","371321114":"铜井镇","371321115":"依汶镇","371321201":"马牧池乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371321.json
// module id = 1344
// module chunks = 0